import React from 'react'
import rzlfh from '../images/rzlfh-icon.svg'
import Heading from '../components/Heading'
import { useEffect } from 'react'
import ListUiUx from '../components/ListUiUx'
import ScrollToTop from '../components/ScrollToTop'
import lightui from '../images/light-ui.svg'


const Uiux = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>

            <img src={lightui} alt="lightui" className='absolute top-0  right-0 w-[70%] lg:w-[40%] -z-10' />

            <main className='px-8 md:px-[7.875em] lg:px-0 grid lg:grid-cols-6 text-center lg:text-left py-4 space-y-8 lg:space-y-12'>

                <div className='mt-[14em] lg:col-start-2 lg:col-end-6 lg:grid lg:grid-cols-4'>
                    <Heading text="UI/UX Design" />
                    <ListUiUx />
                </div>

                <h1 className='font-syncopate font-bold text-[2em] md:text-[2.5em] leading-[3rem] lg:leading-none lg:text-center lg:col-start-2 lg:col-end-6 w-[100%]'>Under Development</h1>
            </main>

            <ScrollToTop />

            <footer className='px-4 md:px-[7.875em] flex items-center justify-between  text-center py-8'>
                <img src={rzlfh} alt="rzlfh" className=' hidden md:block animate-spin-slow' />
                <ul className='flex items-center space-x-14 md:space-x-8 text-center  mx-auto md:mx-0'>
                    <li><a href="https://www.instagram.com/rzlfh/" className='underline opacity-70 hover:opacity-100 ' target="_blank">Instagram</a></li>
                    <li><a href="https://www.linkedin.com/in/rizal-fahadian-281b571b1/" className='underline opacity-70 hover:opacity-100' target="_blank">LinkedIn</a></li>
                    <li><a href="https://github.com/rzlfhh" className='underline opacity-70 hover:opacity-100' target="_blank">Github</a></li>
                </ul>
            </footer>
        </>
    )
}

export default Uiux
